import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Inspector, chromeLight } from 'react-inspector';

const styles = require('./DiagnosticsInspector.scss');

const inspectorTheme = {
    ...chromeLight,
    TREENODE_FONT_FAMILY: 'Menlo, Consolas, monospace',
    TREENODE_FONT_SIZE: '12px',
    OBJECT_NAME_COLOR: 'rgb(180, 0, 158)',
    OBJECT_VALUE_NULL_COLOR: 'rgb(102, 102, 102)',
    OBJECT_VALUE_UNDEFINED_COLOR: 'rgb(102, 102, 102)',
    OBJECT_VALUE_REGEXP_COLOR: 'rgb(232, 17, 35)',
    OBJECT_VALUE_STRING_COLOR: 'rgb(232, 17, 35)',
    OBJECT_VALUE_SYMBOL_COLOR: 'rgb(232, 17, 35)',
    OBJECT_VALUE_NUMBER_COLOR: 'rgb(0, 120, 215)',
    OBJECT_VALUE_BOOLEAN_COLOR: 'rgb(0, 120, 215)',
    OBJECT_VALUE_FUNCTION_KEYWORD_COLOR: 'rgb(216, 59, 1)',
};

export interface DiagnosticsInspectorProps {
    target: Object;
}

/**
 * Shows a dev-tools-like object inspector
 */
export const DiagnosticsInspector = observer((props: DiagnosticsInspectorProps) => (
    <div className={styles.inspectorWrapper}>
        <Inspector data={props.target} expandLevel={1} theme={inspectorTheme} />
    </div>
));
